import type { fleetState } from '@kanbios/api-client';

type Running = fleetState.components['schemas']['Running'];
type Site = Running['sites'][number];
type Container = Running['containers'][number];
type HostUnit = NonNullable<Running['units']>[number];

/**
 * What one deployment owns among what the agent reads on a server: its sites,
 * the containers they serve, its services and cron jobs (D47, D48). Shared by
 * the server's Applications tab and the application page's Briques tab (D51).
 */
export function owned(deployment: string, sites: Site[], containers: Container[], units: HostUnit[]) {
  const mine = sites.filter(s => s.attachedTo?.deployment === deployment);
  const domains = new Set(mine.flatMap(s => s.domains));
  // Every container its sites serve: one site may send /api to the API and the rest to the front.
  const names = new Set(mine.flatMap(s => [...(s.destination?.container ? [s.destination.container] : []), ...s.containers]));
  return {
    sites: mine,
    domains,
    // D48: the bricks the catalogue's rules give it; a container no rule takes goes with the site that serves it.
    // A brick of another deployment stays there, even behind this deployment's site (the front behind the API's site).
    // SPEC-034: a deployment the platform installed runs as the Compose project of its name (no site read: Caddy is in a
    // container), so its containers are its bricks.
    containers: containers.filter(c => (c.brick ? c.brick.deployment === deployment
      : c.compose?.project === deployment || names.has(c.name) || (c.site != null && domains.has(c.site)))),
    units: units.filter(u => u.brick?.deployment === deployment),
  };
}
